import { useEffect } from 'react'
import { SystemControl } from '../classes/SystemControl'
import { useApp } from '../hooks/useApp'
import { useAuth } from '../hooks/useAuth'
import { SESSION_EXPIRED_EVENT } from '../utils/auth'

/**
 * Reload devices on the first rendering and drop the session when it turns out dead.
 * @returns
 */
function Initializer() {

  const app = useApp()
  const { updateMe } = useAuth()

  useEffect(() => {
    if (window.location.pathname === '/') {
      window.location.replace('/app')
    } else if (app.user) {
      updateMe()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [app.user?.id])

  // A 401 on a page that needs no session (see `sessionExpired()`) wipes the storage
  // but leaves the page in place; forget the user read from it as well, so that
  // nothing keeps rendering as if logged in.
  useEffect(() => {
    const onSessionExpired = () => {
      app.setUser(null)
      app.setLocations([])
      app.setInstallerLevel(false)
      SystemControl.setDevices([])
    }
    window.addEventListener(SESSION_EXPIRED_EVENT, onSessionExpired)
    return () => window.removeEventListener(SESSION_EXPIRED_EVENT, onSessionExpired)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <></>
}

export default Initializer
